import $ from 'jquery';

require('slick-carousel/slick/slick');

var $backgroundSlides = $('.header__background_slides');

if ($backgroundSlides.children().length > 1) {
	$backgroundSlides.slick({
		autoplay: true,
		autoplaySpeed: 4000,
		dots: true,
		appendDots: $('.header__foreground_dots'),
		prevArrow: $('.header__foreground_prev'),
		nextArrow: $('.header__foreground_next'),
		asNavFor: '.header__foreground_slider'
	});
}

$('.header__foreground_slider').slick({
	slidesToShow: 1,
	slidesToScroll: 1,
	arrows: false,
	fade: true,
	asNavFor: '.header__background_slides'
});


$('.partner-slider__image-slide').slick({
	autoplay: true,
	dots: true,
	infinite: true,
	arrows: false,
	speed: 400,
	slidesToShow: 4,
	slidesToScroll: 4,
	appendDots: $('.partner-slider__dots'),
	responsive: [
		{
			breakpoint: 1024,
			settings: {
				slidesToShow: 3,
			}
		},
		{
			breakpoint: 600,
			settings: {
				slidesToShow: 2,
			}
		},
		{
			breakpoint: 480,
			settings: {
				slidesToShow: 1,
			}
		}
	]
});

$('.members-slider__image-slide').slick({
	autoplay: true,
	dots: true,
	infinite: true,
	arrows: true,
	speed: 400,
	slidesToShow: 5,
	slidesToScroll: 5,
	appendDots: $('.members-slider__dots'),
	prevArrow: $('.custom-slick-prev'),
	nextArrow: $('.custom-slick-next'),
	responsive: [
		{
			breakpoint: 1024,
			settings: {
				slidesToShow: 3,
			}
		},
		{
			breakpoint: 600,
			settings: {
				slidesToShow: 2,
			}
		},
		{
			breakpoint: 480,
			settings: {
				slidesToShow: 1,
			}
		}
	]
});
